import { stat } from "fs";
import { reactIcons } from "../icons/reactIcons";

export const authCardData = [
  {
    id: 1,
    displayName: "Super Admin",
    route: "/super-admin",
    roles: "super-admin",
  },
  {
    id: 2,
    displayName: "OC-All-IN",
    route: "/oc-all-in",
    roles: "oc_all_in",
  },
  {
    id: 3,
    displayName: "PLC",
    route: "/plc",
    roles: "plc",
  },
  {
    id: 4,
    displayName: "DTS",
    route: "/dts",
    roles: "dts",
  },
  {
    id: 5,
    displayName: "30 For 30",
    route: "/thirty-for-thirty",
    roles: "tft",
  },
];

export const sidebarMenuItems = [
  {
    id: 1,
    parent: "",
    children: [
      {
        id: 1,
        title: "Term Data",
        icon: reactIcons.terDataCalendrCheck,
        path: "/oc-all-in/term-data",
      },
      {
        id: 2,
        title: "Events",
        icon: reactIcons.eventIcon,
        path: "/oc-all-in/events",
      },
      // {
      //   id: 3,
      //   title: "Employees",
      //   icon: reactIcons.employeeIcon,
      //   path: "/employees",
      // },
      {
        id: 4,
        title: "Rewards",
        icon: reactIcons.rewardsIcon,
        path: "/oc-all-in/rewards",
      },
      {
        id: 5,
        title: "Reports",
        icon: reactIcons.reportsicon,
        path: "/oc-all-in/reports",
      },
      // {
      //   id: 6,
      //   title: "FAQ Management",
      //   icon: reactIcons.faqManagementIcon,
      //   path: "/oc-all-in/faq-management",
      // },
    ],
  },
];

export const superAdminSidebaeMenuItems = [
  {
    id: 1,
    parent: "Global",
    children: [
      {
        id: 1,
        title: "Admins",
        icon: reactIcons.student,
        path: "/super-admin/admins",
      },
      {
        id: 2,
        title: "Academic Years",
        icon: reactIcons.terDataCalendrCheck,
        path: "/super-admin/academic-year",
      },
      {
        id: 3,
        title: "Employees",
        icon: reactIcons.employeeIcon,
        path: "/super-admin/employees",
      },
      {
        id: 4,
        title: "Students",
        icon: reactIcons.student,
        path: "/super-admin/students",
      },
    ],
  },
  {
    id: 2,
    parent: "OC-All-IN",
    children: [
      // {
      //   id: 4,
      //   title: "VP Codes",
      //   icon: reactIcons.key,
      //   path: "/super-admin/vp-codes",
      // },
      // {
      //   id: 5,
      //   title: "Departments",
      //   icon: reactIcons.department,
      //   path: "/super-admin/department",
      // },
      {
        id: 6,
        title: "Reward Types",
        icon: reactIcons.medal,
        path: "/super-admin/reward-type",
      },
    ],
  },
  // {
  //   id: 3,
  //   parent: "PLC",
  //   children: [
  //     {
  //       id: 1,
  //       title: "Academic Year",
  //       icon: reactIcons.calender,
  //       path: "/super-admin/plc-academic-year",
  //     },
  //   ],
  // },
];

export const plcSidebarMenuItems = [
  {
    id: 1,
    parent: "",
    children: [
      {
        id: 1,
        title: "Events",
        icon: reactIcons.eventIcon,
        path: "/plc/events",
      },
      {
        id: 2,
        title: "Winners",
        icon: reactIcons.rewardIcon,
        path: "/plc/winners",
      },
      // {
      //   id: 3,
      //   title: "Employees",
      //   icon: reactIcons.employeeIcon,
      //   path: "/plc/employees",
      // },
      {
        id: 4,
        title: "Teams",
        icon: reactIcons.teamIcon,
        path: "/plc/teams",
      },
      {
        id: 5,
        title: "Reports",
        icon: reactIcons.reportsicon,
        path: "/plc/reports",
      },
      {
        id: 6,
        title: "Master",
        icon: reactIcons.masterIcon,
        path: "/plc/master",
      },
      // {
      //   id: 7,
      //   title: "Academic Year",
      //   icon: reactIcons.calender,
      //   path: "/plc/academic-year",
      // },
    ],
  },
];

export const dtsSidebarMenuItems = [
  {
    id: 1,
    parent: "",
    children: [
      {
        id: 1,
        title: "Events",
        icon: reactIcons.eventIcon,
        path: "/dts/events",
      },
      {
        id: 2,
        title: "Event Requests",
        icon: reactIcons.eventRequest,
        path: "/dts/event-requests",
      },
      {
        id: 3,
        title: "Winners",
        icon: reactIcons.rewardIcon,
        path: "/dts/winners",
      },
      {
        id: 4,
        title: "Previous Winners",
        icon: reactIcons.previuosWinners,
        path: "/dts/previous-winners",
      },
      {
        id: 5,
        title: "Prizes",
        icon: reactIcons.prizes,
        path: "/dts/prizes",
      },
      {
        id: 6,
        title: "Sponsors",
        icon: reactIcons.teamIcon,
        path: "/dts/sponsor",
      },
      {
        id: 7,
        title: "Team",
        icon: reactIcons.teamMenbers,
        path: "/dts/team",
      },
      {
        id: 8,
        title: "Reports",
        icon: reactIcons.reportsicon,
        path: "/dts/reports",
      },
      {
        id: 9,
        title: "Master",
        icon: reactIcons.masterIcon,
        path: "/dts/event-category",
      },
    ],
  },
];

export const thirtyForThirtyMenuItem = [
  {
    id: 1,
    parent: "",
    children: [
      {
        id: 1,
        title: "Participants",
        icon: reactIcons.participantsIcon,
        path: "/thirty-for-thirty/participants",
      },
      {
        id: 2,
        title: "Events",
        icon: reactIcons.eventIcon,
        path: "/thirty-for-thirty/event",
      },
      {
        id: 3,
        title: "Challenges",
        icon: reactIcons.challengesIcon,
        path: "/thirty-for-thirty/challenges",
      },
      {
        id: 4,
        title: "Notifications",
        icon: reactIcons.notificationsIcon,
        path: "/thirty-for-thirty/notifications",
      },
      {
        id: 5,
        title: "Winners",
        icon: reactIcons.rewardIcon,
        path: "/thirty-for-thirty/winners",
      },
      {
        id: 6,
        title: "Sponsors",
        icon: reactIcons.teamIcon,
        path: "/thirty-for-thirty/sponsor",
      },
      {
        id: 7,
        title: "Teams",
        icon: reactIcons.teamMenbers,
        path: "/thirty-for-thirty/team",
      },
      {
        id: 8,
        title: "Activities",
        icon: reactIcons.activityIcon,
        path: "/thirty-for-thirty/activity",
      },
      // {
      //   id: 9,
      //   title: "Badges",
      //   icon: reactIcons.badgeIcon,
      //   path: "/thirty-for-thirty/badges",
      // },
      // {
      //   id: 10,
      //   title: "Achievement Badges",
      //   icon: reactIcons.achievementBadge,
      //   path: "/thirty-for-thirty/achievement-badges",
      // },
      {
        id: 11,
        title: "Activity Log",
        icon: reactIcons.reportsicon,
        path: "/thirty-for-thirty/activity-log",
      },
      {
        id: 12,
        title: "Reports",
        icon: reactIcons.reportsicon,
        path: "/thirty-for-thirty/reports",
      },
      // {
      //   id: 13,
      //   title: "Master",
      //   icon: reactIcons.masterIcon,
      //   path: "/thirty-for-thirty/master",
      // },
    ],
  },
];

export const termCodeData = [
  {
    placeHolder: "25F1",
    displayName: "Fall 1",
    termCode: "",
    startDate: null,
    endDate: null,
  },
  {
    placeHolder: "25F2",
    displayName: "Fall 2",
    termCode: "",
    startDate: null,
    endDate: null,
  },
  {
    placeHolder: "25S1",
    displayName: "Spring 1",
    termCode: "",
    startDate: null,
    endDate: null,
  },
  {
    placeHolder: "25S2",
    displayName: "Spring 2",
    termCode: "",
    startDate: null,
    endDate: null,
  },
];

export const event_points = [
  "Main Event (500 Points)",
  "During Workday (100 Points)",
  "After Workday  (200 Points)",
  "Bonus  (300 Points)",
];

export const event_term = ["25F1", "25F2", "26S1", "26S2"];

export const employeeFormStatusData = [];

export const rewardCollectionData = [
  {
    id: 1,
    label: "Fall 1",
    status: true,
  },
  {
    id: 2,
    label: "Fall 2",
    status: false,
  },
  {
    id: 3,
    label: "Spring 1",
    status: false,
  },
  {
    id: 4,
    label: "Spring 2",
    status: false,
  },
  {
    id: 5,
    label: "December Bonus",
    status: false,
  },
  {
    id: 6,
    label: "OC Success Reward",
    status: false,
  },
];

export const rewarsNonEligibleEmployeeheaders = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Event Points",
  "Selected Rewards",
  "Reward Amount ($)",
];

export const reportEventDetailsData = {
  "Event Name": "Convacation",
  "Event Location": "Sports Center",
  "Event Code": "2314",
  "Event Points": "Main Event (500 points)",
  "Event Date": "2026-01-31 | 10:00 AM",
  Term: "YYF1",
  "Hidden?": "NO",
  "Allow Early Check In?": "YES",
};

export const rewardEmployeeAttendance = [
  {
    employee_id: "EMP001",
    email: "john.doe@company.com",
    firstName: "John",
    lastName: "Doe",
    check_in_date_time: "2026-01-31 09:15 AM",
  },
  {
    employee_id: "EMP002",
    email: "jane.smith@company.com",
    firstName: "Jane",
    lastName: "Smith",
    check_in_date_time: "2026-01-31 09:18 AM",
  },
  {
    employee_id: "EMP003",
    email: "rahul.kumar@company.com",
    firstName: "Rahul",
    lastName: "Kumar",
    check_in_date_time: "2026-01-31 09:22 AM",
  },
  {
    employee_id: "EMP004",
    email: "anita.sharma@company.com",
    firstName: "Anita",
    lastName: "Sharma",
    check_in_date_time: "2026-01-31 09:30 AM",
  },
  {
    employee_id: "EMP005",
    email: "michael.brown@company.com",
    firstName: "Michael",
    lastName: "Brown",
    check_in_date_time: "2026-01-31 09:35 AM",
  },
];

export const SuccessRewardTableHeader = [
  "Employee ID",
  "VP Code",
  "First Name",
  "Last Name",
  "Fall 1 Points",
  "Fall 2 Points",
  "Spring 1 Points",
  "Spring 2 Points",
  "Selected Rewards",
  "Selected Term",
  "Award Amount ($)",
];

export const finalDrawingHeader = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Fall 1 Points",
  "Fall 2 Points",
  "Spring 1 Points",
  "Spring 2 Points",
  "Entries",
];

export const employeeTypeStatus = [
  { id: "FT", displayName: "FT" },
  { id: "PT", displayName: "PT" },
];

export const employeeDepartmentData = [
  { id: "Physical Plant", displayName: "Physical Plant" },
  { id: "Social Science", displayName: "Social Science" },
  { id: "Testing Center", displayName: "Testing Center" },
  { id: "IT", displayName: "IT" },
];

export const employeeVPCodeData = [
  { id: "VP", displayName: "VP" },
  { id: "VPBA", displayName: "VPBA" },
  { id: "VPI", displayName: "VPI" },
  { id: "VPM", displayName: "VPM" },
];

export const rewardGiftCardData = [
  { id: "1", displayName: "Amazon" },
  { id: "2", displayName: "Academy" },
  { id: "3", displayName: "Apple Store" },
  { id: "4", displayName: "Best Buy" },
];

export const totalTermPontsTableHeader = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Event Points",
];

export const completionStatisticsByTermHeader = [
  "Employee ID",
  "VP Code",
  "First Name",
  "Last Name",
  "Event Points",
  "DD",
  "TD",
];

export const pointsListedByVpHeader = [
  "Employee ID",
  "First Name",
  "Last Name",
  "Event Points",
];

export const eventAttandanceHeaders = [
  "Participant ID",
  "Email",
  "First Name",
  "Last Name",
  "Check In Date & Time",
];

export const individualPointSummaryXlHeader = [
  "Event",
  "Event Code",
  "Location",
  "Points",
  "Event Date",
];

export const employeeListHeaders = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Status",
  "Department",
  "Web ID",
  "VP Code",
];

export const eventEmployee = [
  {
    id: 1,
    label: "Add Employee",
  },
  {
    id: 2,
    label: "Delete Employee",
  },
];

export const employeeMenu = [
  {
    id: 1,
    label: "Add Event",
  },
  {
    id: 2,
    label: "Delete Event",
  },
];

export const plcMasterTabData = [
  {
    id: 1,
    displayName: "Event Type",
  },
  {
    id: 2,
    displayName: "Event Category",
  },
  {
    id: 3,
    displayName: "Team Settings",
  },
];

export const plcTeamsListData = [
  {
    id: 1,
    teamName: "The Thunderbolts",
    type: "Public",
    members: 5,
    teamPassword: "T6u5V4w3",
    createdBy: "Alex Turner (987654)",
    createdOn: "2025-08-12|10:00 AM",
  },
  {
    id: 1,
    teamName: "The Thunderbolts",
    type: "Public",
    members: 5,
    teamPassword: "T6u5V4w3",
    createdBy: "Alex Turner (987654)",
    createdOn: "2025-08-12|10:00 AM",
  },
  {
    id: 1,
    teamName: "The Thunderbolts",
    type: "Private",
    members: 5,
    teamPassword: "T6u5V4w3",
    createdBy: "Alex Turner (987654)",
    createdOn: "2025-08-12|10:00 AM",
  },
];

export const plcEventsData = [
  { id: 1, displayName: "Individual Events" },
  { id: 2, displayName: "Team Events" },
];

export const plcWinnersTabData = [
  { id: 1, displayName: "Individual Events" },
  { id: 2, displayName: "Teams Events" },
];

export const plcEventListData = [
  {
    id: 1,
    event: "Inovation Summit",
    code: "4651",
    status: "Up comming",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 2,
    event: "Inovation Summit",
    code: "4651",
    status: "Ongoing",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 3,
    event: "Inovation Summit",
    code: "4651",
    status: "Completed",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 4,
    event: "Inovation Summit",
    code: "4651",
    status: "Up comming",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 5,
    event: "Inovation Summit",
    code: "4651",
    status: "Up comming",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 6,
    event: "Inovation Summit",
    code: "4651",
    status: "Up comming",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 7,
    event: "Inovation Summit",
    code: "4651",
    status: "Up comming",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 8,
    event: "Inovation Summit",
    code: "4651",
    status: "Up comming",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 9,
    event: "Inovation Summit",
    code: "4651",
    status: "Up comming",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
  {
    id: 10,
    event: "Inovation Summit",
    code: "4651",
    status: "Up comming",
    participants: 13,
    event_date_time: "2025-08-12|10:00 AM",
    plcCredit: 1,
    location: "Hyderabad",
    eventType: "Career enhacment",
    category: "PLC 2026",
  },
];

export const plcWinnersExportHeaders = (tab: string) => {
  let headers = [
    "Event",
    "Code",
    tab === "individual" ? "Participants" : "Team",
    "Event Date & Time",
    "PLC Credit",
    "Event Type",
    "Category",
    "Winner",
  ];

  return headers;
};

export const plcTeamsSumaryColumns = [
  { header: "Employee ID", accessor: "employeeId" },
  { header: "Email", accessor: "email" },
  { header: "First Name", accessor: "firstName" },
  { header: "Last Name", accessor: "lastName" },
  { header: "Department", accessor: "department" },
];

export const plcTeamEventDetailsHeaders = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Department",
];

export const plcIndividualEventListMenuData = (status: string) => {
  if (status === "upcoming") {
    return [
      { id: 1, label: "Edit" },
      { id: 2, label: "Delete" },
      { id: 3, label: "Export" },
    ];
  } else {
    return [
      //{ id: 1, label: "Edit" },
      // { id: 2, label: "Delete" },
      { id: 3, label: "Add Employee" },
      { id: 4, label: "Delete Employee" },
      { id: 5, label: "Export" },
    ];
  }
};

export const plcTeamEventListMenuData = (status: string) => {
  if (status === "upcoming") {
    return [
      { id: 1, label: "Edit" },
      { id: 2, label: "Delete" },
      { id: 3, label: "Export" },
    ];
  } else {
    return [
      //{ id: 1, label: "Edit" },
      // { id: 2, label: "Delete" },
      { id: 3, label: "Export" },
    ];
  }
};

export const admin_role_data = [
  { id: "1", displayName: "Admin" },
  { id: "2", displayName: "Super Admin" },
];

export const assignedFeaturesData = [
  { id: "1", displayName: "PLC" },
  { id: "2", displayName: "OC All-In" },
  { id: "3", displayName: "Super Admin" },
];

export const studentListHeaders = [
  "Student ID",
  "First Name",
  "Last Name",
  "Email",
];

export const plcCredit = [
  { id: "1", displayName: "1" },
  { id: "2", displayName: "2" },
  { id: "3", displayName: "3" },
];

export const plcEvents_headers = [
  "Event Name",
  "Event Code",
  "Status",
  "Participants",
  "Event Date & Time",
  "PLC Credit",
  "Location",
  "Event Type",
  "Category",
];

export const plcReportsTabData = [
  { id: 1, displayName: "Event Attendance" },
  { id: 2, displayName: "Event Points by Team" },
  { id: 3, displayName: "Individual Credit Summary" },
  { id: 4, displayName: "Total Credit Summary" },
];

export const plc_event_team_attendence_header = ["Team Name", "Participants"];

export const plc_event_atendence_individual_headers = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Check In Date & Time",
  "Presenter",
];

export const plc_event_attendence_team_headers = ["Team Name", "Participates"];

export const plc_individual_credit_summary_headers = [
  "Event",
  "Event Code",
  "Location",
  "PLC Credits",
  "Event Date & Time",
  "Presenter",
];

export const plc_teamPoints_table_header = [
  "Team Name",
  "Type",
  "Team Password",
  "Created by",
  "Created on",
  "Members",
  "Event Points",
];

export const plc_total_credit_summary_header = [
  "Employee ID",
  "Employment Type",
  "Email",
  "First Name",
  "Last Name",
  "Employee Department",
  "Employee VP Code",
  "Employee Web ID",
  "Total Credits",
];

export const dtsMenuItemsForUpcommingEvent = [
  { id: 1, label: "Edit" },
  { id: 2, label: "Delete" },
  { id: 6, label: "View QR" },
];

export const dtsMenuItemsForOngoingEvent = [
  // { id: 1, label: "Edit" },
  // { id: 2, label: "Delete" },
  { id: 3, label: "Add Student" },
  { id: 4, label: "Delete Student" },
  { id: 5, label: "Export" },
  { id: 6, label: "View QR" },
];

export const dtsMenuItemsForOngoingAndCompletedEvent = [
  // { id: 1, label: "Edit" },
  // { id: 2, label: "Delete" },
  { id: 3, label: "Add Student" },
  { id: 4, label: "Delete Student" },
  { id: 5, label: "Export" },
];

export const dtsEventPointsData = [
  { id: "1", displayName: "1" },
  { id: "2", displayName: "2" },
  { id: "5", displayName: "5" },
  { id: "10", displayName: "10" },
];

export const dtsExportEventsTableHeaders = [
  "Event",
  "Code",
  "Status",
  "Participants",
  "Event Date & Time",
  "Points",
  "Category",
  "Location",
];

export const eventRequestTabData = [
  { id: 1, displayName: "New Requests" },
  { id: 2, displayName: "Accepted" },
  { id: 3, displayName: "Rejected" },
];

export const previousWinnersMenuData = [
  { id: 1, label: "Edit Year" },
  { id: 2, label: "Delete Year" },
];

export const winnerTabData = [
  { id: 1, displayName: "Term" },
  { id: 2, displayName: "Annual" },
];

export const dtsWinnersIndividualWinners = [
  "Event",
  "Code",
  "Participants",
  "Event Date & Time",
  "Event Points",
  "Category",
  "Winner",
];

export const dtsReportsTabData = [
  { id: 1, displayName: "Event Attendance" },
  { id: 2, displayName: "Individual Event Points Summary" },
  { id: 3, displayName: "Event Points by Term" },
  { id: 4, displayName: "Events by Term" },
];

export const dtsTermPointsTableHeader = [
  "Student ID",
  "Email",
  "First Name",
  "Last Name",
  "Event Points",
];

export const dtsEventParticipantsTableHeaders = [
  "Student ID",
  "Email",
  "First Name",
  "Last Name",
  "Check In Date & Time",
];

export const dtsIndividualPointSummaryExportHeaders = [
  "Event",
  "Event Code",
  "Location",
  "Event Points",
  "Event Date & Time",
];

export const tft_participants_exportColumns = [
  { header: "Participants ID", accessor: "participantId" },
  { header: "Name", accessor: "name" },
  { header: "Email", accessor: "contact" },
  { header: "Age Range", accessor: "ageRange" },
  { header: "Team Name", accessor: "teamName" },
  { header: "Registration Date", accessor: "registrationDate" },
  { header: "Status", accessor: "isActive" },
  { header: "Participant", accessor: "participantCategoryName" },
  { header: "How did you hear about 30-for-30?", accessor: "source" },
  { header: "What is your fitness goal?", accessor: "fitnessGoal" },
  { header: "Event T-shirt size", accessor: "tshirtSize" },
];

export const dts_eventsByTermExportTableHeaders = [
  "Event",
  "Code",
  "Status",
  "Participants",
  "Event Date & Time",
  "Event Points",
  "Category",
  "Location",
];

export const tftParticipantsExportHeaders = [
  "Participants ID",
  "Name",
  "Email",
  "Age Range",
  "Team Name",
  "Registration Date",
  "Status",
  "Participant",
  "How did you hear about 30-for-30?",
  "What is your fitness goal?",
  "Event T-shirt size",
];

export const tftEventMenuData = [
  // { id: 1, label: "Edit" },
  { id: 3, label: "Export" },
];

export const tftEventMenuStatusData = [
  { id: 1, label: "Edit" },
  { id: 2, label: "Delete" },
  //{ id: 3, label: "Export" },
];

export const tftParticipantsFilterHeaderMenuItemData = [
  { id: 1, label: "All Participants" },
  { id: 2, label: "Deactivated Participants" },
  { id: 3, label: "Activated Participants" },
];

export const tftEventExportHeaders = [
  "Event",
  "Code",
  "Status",
  "Participants",
  "Event Date & Time",
];

export const tFtParticipantsFilterData = [
  { id: "1", displayName: "All Participants" },
  { id: "2", displayName: "Employee" },
  { id: "3", displayName: "Student" },
  { id: "4", displayName: "OC Alumini" },
  { id: "5", displayName: "Community Member" },
  { id: "6", displayName: "Sports Center Member" },
  { id: "7", displayName: "UTPB Employee/Student" },
];

export const tftParticipantsMenuItemData = [
  // { id: 1, label: "Edit" },
  { id: 2, label: "Resend Registration Email" },
];

export const tftChallengesMenuData = (row: any) => {
  if (row.status === "upcoming" && !row?.showStopRegistrationButton) {
    return [
      { id: 1, label: "Edit" },
      { id: 2, label: "Delete" },
    ];
  } else if (row.status === "upcoming" && row?.showStopRegistrationButton) {
    return [
      { id: 1, label: "Edit" },
      { id: 2, label: "Delete" },
      { id: 3, label: "Stop Registration" },
    ];
  } else {
    return [
      //{ id: 1, label: "Edit" },
      // { id: 2, label: "Delete" },
      { id: 3, label: "Export" },
    ];
  }
};

export const challengesNotificationData = [
  { id: "1", displayName: "May Challenge" },
  { id: "2", displayName: "June Challenge" },
  { id: "3", displayName: "July CHallenge" },
];

export const participantsNotificationData = [
  { id: "1", displayName: "Venkat" },
  { id: "2", displayName: "Suresh" },
  { id: "3", displayName: "Kiran" },
];

export const tftActivityDropDownData = [
  { id: "1", displayName: "Minutes", unit: "minutes" },
  { id: "2", displayName: "Count", unit: "steps" },
  {
    id: "3",
    displayName: "Completed/Incomplete",
    unit: "Completed/Incomplete",
  },
];

export const tftChallengesExportTableHeaders = [
  "Participant ID",
  "Email",
  "First Name",
  "Last Name",
  "Check In Date & Time",
];

export const tftWinnersParticipantsDetailsTableHeaders = [
  "Participant ID",
  "Email",
  "First Name",
  "Last Name",
  "Registration Date & Time",
];

export const tftWinnersTabData = [
  { id: 1, displayName: "Events" },
  { id: 2, displayName: "Participants" },
  { id: 3, displayName: "Kids Grand Prize" },
  { id: 4, displayName: "Adult Grand Prize" },
  { id: 5, displayName: "OC Student Grand Prize" },
];

export const tftActivityLogExportTableHeaders = [
  "Day",
  "Date",
  "Actvity",
  "Activity Value",
  "Updated On",
];

export const tftTeamDetailsTableHeaders = [
  { header: "Participant ID", accessor: "participantId" },
  { header: "Name", accessor: "name" },
  { header: "Email", accessor: "email" },
  { header: "Age Range", accessor: "ageRange" },
];

export const tftReportsTabData = [
  { id: 1, displayName: "Participant Completion" },
  { id: 2, displayName: "OC Employees Eligible for All-In Points" },
  { id: 3, displayName: "OC Students Eligible for DTS Points" },
  { id: 4, displayName: "Team Rankings" },
];

export const tftEligibleOcPointsData = [
  {
    id: 1,
    title: "Stage 1 :  09/01 - 09/10 Complete for 100 points",
    data: [
      {
        id: "1",
        employeeId: "7412021",
        name: "Huzaifa Noori",
        code: "",
        email: "huzaifanoori@yopmail.com",
      },
      {
        id: "2",
        employeeId: "7412022",
        name: "Mashu Allam",
        code: "",
        email: "huzaifanoori@yopmail.com",
      },
      {
        id: "3",
        employeeId: "7412023",
        name: "Bharath Reddy",
        code: "491202",
        email: "huzaifanoori@yopmail.com",
      },
    ],
  },
  {
    id: 2,
    title: "Stage 2 :  09/11 - 09/20 Complete for 100 points",
    data: [
      {
        id: "1",
        employeeId: "7412021",
        name: "Huzaifa Noori",
        code: "",
        email: "huzaifanoori@yopmail.com",
      },
      {
        id: "2",
        employeeId: "7412022",
        name: "Mashu Allam",
        code: "",
        email: "huzaifanoori@yopmail.com",
      },
      {
        id: "3",
        employeeId: "7412023",
        name: "Bharath Reddy",
        code: "491202",
        email: "huzaifanoori@yopmail.com",
      },
    ],
  },
];

export const tftEligibleOcEmployeesExportTableData = (employee: string) => {
  return [
    "Participant ID",
    employee ? "Employee ID" : "Student ID",
    "Name",
    "Email",
  ];
};

export const tft_Event_Winners_List_Export_data = [
  "Event",
  "Code",
  "Participants",
  "Event Date & Time",
  "Winner",
];

export const tft_Participants_winners_list_export_data = [
  "Challenges",
  "Participants",
  "Challenge Date & Time",
  "Winner",
];

export const tft_winner_category_export_data = [
  "Challenges",
  "Winners",
  "Challenges Date & Time",
];

export const handleTftWinnerCategoryInnerHeaders = (type: string) => {
  let tableHeaders = [
    "Participant ID",
    "Name",
    "Age Range",
    "Total Days Completed Activity",
    "Registration Date & Time",
  ];
  if (type === "kids") {
    return tableHeaders;
  } else {
    let headers = tableHeaders.splice(0, tableHeaders.length - 1);
    return headers;
  }
};

export const tftTeamDetailsExportHeaders = [
  "Participant ID",
  "Name",
  "Email",
  "Age Range",
];

export const tftActivityExportHeaders = [
  "Day",
  "Date",
  "Activity",
  "Activity Value",
  "Updated On",
];

export const tftReportParticipantCompletionDetailsExportHeader = [
  "Participant ID",
  "Name",
  "Age Range",
  "Total Days Completed Activity",
];

export const tftReportsTeamRankingExportHeader = [
  "Rank",
  "Team Name",
  "Team Members",
  "Team Participation Score",
];

export const tftTeamDetailsTabData = [
  { id: 1, displayName: "Week 1" },
  { id: 2, displayName: "Week 2" },
  { id: 3, displayName: "Week 3" },
  { id: 4, displayName: "Week 4" },
  { id: 5, displayName: "Week 5" },
];

export const tftBadgeTabsData = [
  { id: "individual", displayName: "Individual" },
  { id: "team", displayName: "Team" },
];

export const tftBadgeWeekOptions = [
  { id: "Week 1", displayName: "Week 1" },
  { id: "Week 2", displayName: "Week 2" },
  { id: "Week 3", displayName: "Week 3" },
  { id: "Week 4", displayName: "Week 4" },
  { id: "Week 5", displayName: "Week 5" },
];

export const tftBadgeLeaderboardOptions = [
  { id: "Main Leaderboard", displayName: "Main Leaderboard" },
  { id: "Exercise Leaderboard", displayName: "Exercise Leaderboard" },
];

export const tftBadgePlaceOptions = [
  { id: "1st, 2nd, 3rd place", displayName: "1st, 2nd, 3rd place" },
  { id: "4th - 10th place", displayName: "4th - 10th place" },
  { id: "Top 50", displayName: "Top 50" },
];

export const tftBadgeActivityOptions = [
  { id: "Daily Steps", displayName: "Daily Steps" },
  { id: "Cardio", displayName: "Cardio" },
];

export const tftStaticBadgesData = [
  {
    id: "badge-1",
    title: "One of the Team!",
    description: "Joined a team for the 2025 fitness challenges",
    leaderboard: "Main Leaderboard",
    activity: "",
    place: "1st, 2nd, 3rd place",
    logoTheme: "silver",
  },
  {
    id: "badge-2",
    title: "Bring it on!",
    description: "Participant in 2025",
    leaderboard: "Main Leaderboard",
    activity: "",
    place: "4th - 10th place",
    logoTheme: "gold",
  },
  {
    id: "badge-3",
    title: "Participant in 2025",
    description: "Participant in 2025",
    leaderboard: "Main Leaderboard",
    activity: "",
    place: "Top 50",
    logoTheme: "red",
  },
  {
    id: "badge-4",
    title: "Bring it on!",
    description: "Participant in 2025",
    leaderboard: "Exercise Leaderboard",
    activity: "Daily Steps",
    place: "1st, 2nd, 3rd place",
    logoTheme: "silver",
  },
  {
    id: "badge-5",
    title: "Participant in 2025",
    description: "Participant in 2025",
    leaderboard: "Exercise Leaderboard",
    activity: "Daily Steps",
    place: "4th - 10th place",
    logoTheme: "gold",
  },
  {
    id: "badge-6",
    title: "Bring it on!",
    description: "Participant in 2025",
    leaderboard: "Exercise Leaderboard",
    activity: "Cardio",
    place: "Top 50",
    logoTheme: "red",
  },
  {
    id: "badge-7",
    title: "Participant in 2025",
    description: "Participant in 2025",
    leaderboard: "Exercise Leaderboard",
    activity: "Cardio",
    place: "1st, 2nd, 3rd place",
    logoTheme: "silver",
  },
  {
    id: "badge-8",
    title: "Bring it on!",
    description: "Participant in 2025",
    leaderboard: "Exercise Leaderboard",
    activity: "Cardio",
    place: "4th - 10th place",
    logoTheme: "gold",
  },
  {
    id: "badge-9",
    title: "Participant in 2025",
    description: "Participant in 2025",
    leaderboard: "Exercise Leaderboard",
    activity: "",
    place: "Top 50",
    logoTheme: "red",
  },
];

export const tftAchievementBadgeTabsData = [
  { id: "individual", displayName: "Individual Badges" },
  { id: "team", displayName: "Team Badges" },
];

export const tftAchievementIndividualData = [
  {
    id: "individual-achievement-1",
    week: "Week 1",
    rank: 1,
    participantName: "#191 - Wendy Serrano",
    totalExerciseMinutes: 1080,
    totalExerciseDays: 6,
  },
  {
    id: "individual-achievement-2",
    week: "Week 1",
    rank: 1,
    participantName: "#199 - Jose Carrillo",
    totalExerciseMinutes: 1080,
    totalExerciseDays: 6,
  },
  {
    id: "individual-achievement-3",
    week: "Week 1",
    rank: 3,
    participantName: "#207 - Maya Johnson",
    totalExerciseMinutes: 990,
    totalExerciseDays: 6,
  },
  {
    id: "individual-achievement-4",
    week: "Week 2",
    rank: 1,
    participantName: "#144 - Priya Raman",
    totalExerciseMinutes: 1210,
    totalExerciseDays: 7,
  },
  {
    id: "individual-achievement-5",
    week: "Week 2",
    rank: 2,
    participantName: "#166 - Ben Foster",
    totalExerciseMinutes: 1165,
    totalExerciseDays: 7,
  },
];

export const tftAchievementTeamData = [
  {
    id: "team-achievement-1",
    week: "Week 1",
    rank: 1,
    teamName: "A Lo At Steak",
    weeklyTeamParticipationScore: "100%",
  },
  {
    id: "team-achievement-2",
    week: "Week 1",
    rank: 1,
    teamName: "Way Makers",
    weeklyTeamParticipationScore: "100%",
  },
  {
    id: "team-achievement-3",
    week: "Week 1",
    rank: 3,
    teamName: "Step It Up",
    weeklyTeamParticipationScore: "96%",
  },
  {
    id: "team-achievement-4",
    week: "Week 2",
    rank: 1,
    teamName: "Moving Forward",
    weeklyTeamParticipationScore: "100%",
  },
  {
    id: "team-achievement-5",
    week: "Week 2",
    rank: 2,
    teamName: "Goal Getters",
    weeklyTeamParticipationScore: "98%",
  },
];

export const tftAchievementIndividualExportHeaders = [
  "Rank",
  "Participant Name",
  "Total Exercise Minutes",
  "Total Exercise Days",
];

export const tftAchievementTeamExportHeaders = [
  "Rank",
  "Team Name",
  "Weekly Team Participation Score",
];
